export default "__VITE_ASSET__BTZxZjCn__"